import ContractHeader from 'components/common/tables_header/contract_header';
import CustomDropdown from 'components/dropdown/custom_select';
import WorkShiftCalendar from 'components/tables/work_shift_calendar';
import { FormikProps } from 'formik';
import useMember from 'hooks/useMember';
import { useEffect, useState } from 'react';

type WorkingDaysProps = {
  countries: any;
  user?: any;
  onUpdateData?: (data: object) => void;
  role?: string;
  formik?: FormikProps<any>;
};

const WorkingDays = ({
  countries,
  user,
  onUpdateData,
  role,
  formik,
}: WorkingDaysProps) => {
  const { filterHolidayCalendarOption, getWorkshiftListOption, getManagers } = useMember();
  const [holidaySelect, setHolidaySelect] = useState([]);
  const [workShiftData, setWorkShiftData] = useState([]);
  const [listManagers, setListManagers] = useState([]);
  const [state, setState] = useState({
    addCalendar: false,
    data: user,
  });
  const onClose = () => {
    setState((pre) => ({
      ...pre,
      addCalendar: false,
    }));
  };

  const { addCalendar, data } = state;

  const getListManager = async () => {
    if (!user?.department_id || !user?.role) return;
    try {
      const res = await getManagers({
        department_id: user?.department_id,
        role: user?.role,
      });
      if (res.status === 200) {
        if (res.data?.results?.length > 0) setListManagers(res.data?.results);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    setState((pre) => ({
      ...pre,
      data: user,
    }));
  }, [user]);
  const managerList = user?.managers?.map((x) => ({
    label: `${x.first_name} ${x.last_name}`,
    value: x['id'],
  }))


  useEffect(() => {
    getListManager();

    getWorkshiftListOption().then((res) => {

      setWorkShiftData(
        res?.map((item: { id: number; name: string }) => {
          return {
            label: item.name,
            value: item.id,
            ...item,
          };
        }),
      );
    });
    filterHolidayCalendarOption().then((res) => {

      setHolidaySelect(
        res?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        }),
      );
    });
  }, []);

  return (
    <div>
      <h1 style={{ fontWeight: 500, fontSize: 20, color: '#000000' }}>
        Working Days
      </h1>
      <div style={{ width: '100%', marginTop: '32px' }}>
        <CustomDropdown
          disabled={role !== 'admin'}
          value={formik?.values.public_holiday_calendar_id}
          onSelect={(v: string) => {
            formik.setFieldValue('public_holiday_calendar_id', v);
          }}
          height={50}
          fontSize={12}
          defaultBorder="6px"
          defaultKey={user?.public_holiday_calendar_id}
          title="Calendar ( public holidays )"
          options={holidaySelect}
          width="100%"
        />
      </div>
      <div
        style={{
          paddingTop: 10,
          fontSize: 12,
          fontWeight: 400,
          color: '#898989',
        }}
      >
        France ( by default )
      </div>
      <h1
        style={{
          marginTop: 32,
          fontWeight: 500,
          fontSize: 16,
          color: '#000000',
        }}
      >
        Work Shift Calendars
      </h1>
      <div
        style={{
          width: '100%',
          marginTop: '15px',
          display: 'flex',
          gap: '11px',
        }}
      >
        <img src="/icons/danger.svg" alt="imgae" />
        <span style={{ color: '#E02C2C' }}>
          If there is no date defined in the table below, the company’s default
          work shift calendar is applied.
        </span>
      </div>
      {user?.workshifts?.length === 0 && <div
        onClick={() => setState((pre) => ({ ...pre, addCalendar: true }))}
        className="add_user_second_step_button"
      >
        <img src="/icons/new_button.svg" alt="button" />
        Add item
      </div>}
      {/* TABLE */}
      <div
        className="employee_directory_filter_table"
        style={{ width: '100%', marginTop: '30px' }}
      >
        <ContractHeader />
        <WorkShiftCalendar
          role={role}
          workShiftList={workShiftData}
          data={user?.workshifts && user?.workshifts}
          onClose={onClose}
          addCalendar={addCalendar}
          parentFormik={formik}
        />
      </div>
      <h2
        style={{
          marginTop: '32px',
          color: '#000000',
          fontWeight: 500,
          fontSize: 20,
        }}
      >
        Manager
      </h2>
      <div
        style={{
          display: 'flex',
          gap: '32px',
          width: '100%',
          marginTop: '32px',
        }}
      >
        <div
          style={{
            width: '49%',
          }}
        >
          <CustomDropdown
            disabled
            width="100%"
            title="Manager"
            showIconWhenDisabled
            height="50px"
            fontSize={12}
            value={user?.managers[0]?.id}
            defaultKey={user?.managers[0]?.id}

            options={managerList}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkingDays;
